/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useState, useEffect } from "react";

/**
 * Wrapper for useState that will save data to local storage on change
 * @param {string} key local storage key
 * @param {any} initial initial state value
 */
const useLocalState = (key, initial) => {
	const [value, setValue] = useState(() => {
		if (typeof window !== "undefined") {
			const saved = window.localStorage.getItem(key);

			if (saved !== null) {
				return JSON.parse(saved);
			}
		}

		return initial;
	});

	useEffect(() => {
		window.localStorage.setItem(key, JSON.stringify(value));
	}, [value, key]);

	return [value, setValue];
};

export default useLocalState;
